import { ArrowRightIcon, CheckCircleIcon, WarningIcon, WarningTwoIcon } from '@chakra-ui/icons';
import { CircularProgress, Text } from '@chakra-ui/react';
import {
  AccountApiLogsGetImportExecutionResponse,
  AccountApiLogsGetImportExecutionsImportExecutionResponse,
} from '@netiva/classifieds-api';
import { FC, ReactNode } from 'react';
import { useTranslation } from 'react-i18next';

export const ImportLogStatus: FC<{
  execution: AccountApiLogsGetImportExecutionResponse | AccountApiLogsGetImportExecutionsImportExecutionResponse;
}> = ({ execution }) => {
  const { t } = useTranslation();

  let icon: ReactNode | null = null;
  let text: string | null = null;

  switch (execution.queueStatus) {
    case 'Queued':
      icon = <ArrowRightIcon color="blue" boxSize={4} mr={2} />;
      text = t('api.importLogs.status.queued');
      break;
    case 'Started':
      icon = <CircularProgress as="span" color="blue" size={4} mr={2} isIndeterminate />;
      text = t('api.importLogs.status.running');
      break;
    case 'Finished':
      {
        switch (execution.resultStatus) {
          case 'Success':
            icon = <CheckCircleIcon color="green" boxSize={4} mr={2} />;
            text = t('api.importLogs.status.success');
            break;
          case 'Warning':
            icon = <WarningTwoIcon color="orange" boxSize={4} mr={2} />;
            text = t('api.importLogs.status.warning');
            break;
          case 'Error':
            icon = <WarningIcon color="red" boxSize={4} mr={2} />;
            text = t('api.importLogs.status.error');
            break;
        }
      }
      break;
  }

  if (!text || !icon) {
    return null;
  }

  return (
    <Text>
      {icon}
      {text}
    </Text>
  );
};
